import { render } from "./LogisticsProviderView.vue?vue&type=template&id=073a80b0&scoped=true"
import script from "./LogisticsProviderView.vue?vue&type=script&lang=js"
export * from "./LogisticsProviderView.vue?vue&type=script&lang=js"

import "./LogisticsProviderView.vue?vue&type=style&index=0&id=073a80b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073a80b0"]])

export default __exports__